// Borrowed from https://github.com/burocratik/outdated-browser
var supports = (function () {
    var div = document.createElement('div');
    var vendors = 'Khtml Ms O Moz Webkit'.split(' ');
    var len = vendors.length;

    return function (prop) {
        if (prop in div.style) return true;

        prop = prop.replace(/^[a-z]/, function (val) {
            return val.toUpperCase();
        });

        while (len--) {
            if (vendors[len] + prop in div.style) {
                return true;
            }
        }
        return false;
    };
})();

function checkBrowser() {
    this.unsupportedBrowser = false;

    if (isIE() || !supports('borderImage')) { // added the supports border image as a broader check to capture compatibility mode setups
        this.unsupportedBrowser = true; // No versions of IE are supported anymore.
        $('html').addClass('ie');
    }

    if (isEdge()) {
        $('html').addClass('edge');
    }

    if (this.unsupportedBrowser && localStorage.getItem('unsupported_alert') !== 'false') {
        $('#unsupportedBrowserAlert').slideDown(750);
    }
}

function dismissUnsupported(dismissButton) {
    $(dismissButton).parent().parent().slideUp(750);
    localStorage.setItem('unsupported_alert', 'false');
}
